@if (pageForm) {
  <div class="credit-info-container flex flex-column gap-3 mb-5" [formGroup]="pageForm">
    <div>
      <span class="title">
        <app-translate key="ATT_BUSINESS_AGREEMENT"></app-translate>
      </span>
    </div>
    <div>
      <span class="sub-title">
        <app-translate key="PURCHASE_REQUIRES_AGREEMENT_ACCEPTANCE"></app-translate>
      </span>
    </div>
    <p-divider></p-divider>
    <div>
      <span class="sub-title">
        <app-translate key="MBA_CONGRATULATIONS"></app-translate>
      </span>
    </div>
    <div class="border-round">
      <!-- AT&T Multi-Service Agreement (Master Agreement) — shown above the AMB section when applicable -->
      @if (showMasterAgreement && pageForm.controls['masterAccepted']) {
        <div class="mb-4">
          <div class="flex mb-2">
            <span class="font-semibold text-xl">{{ masterAgreementTitle }}</span>
          </div>
          <div class="sub-title mb-3">
            <a [href]="masterAgreementUrl" target="_blank"
              (click)="onAgreementLinkClick(masterAgreementUrl, 'masterAccepted'); $event.preventDefault()"
              class="color-sara-blue">
              <app-translate key="CLICK_READ_TERMS"></app-translate>
            </a>
          </div>
          <div class="sub-title">
            <div class="checkbox-span">
              <p-checkbox inputId="masterAccepted" formControlName="masterAccepted" [binary]="true"
                (onChange)="onAgreementChecked('masterAccepted', $event)" />
              <label for="masterAccepted" class="ml-2 sub-title agreement-term" [innerHTML]="masterAgreementTermHtml"></label>
            </div>
            <sp-control-error [control]="pageForm.controls['masterAccepted']"
              [messagesParameters]="[{ key: 'required', message: languageService.getTranslation('FIELD_MUST_BE_CONFIRMED') }]">
            </sp-control-error>
          </div>
          <p-divider></p-divider>
        </div>
      }
      <!-- AT&T Mobile Business Pricing Schedule -->
      <div class="mb-4">
        <div class="flex mb-2">
          <span class="font-semibold text-xl">{{ ambAgreementTitle }}</span>
        </div>
        <div class="sub-title mb-3">
          <a [href]="ambAgreementFileUrl" target="_blank"
            (click)="onAgreementLinkClick(ambAgreementFileUrl, 'ambAccepted'); $event.preventDefault()"
            class="color-sara-blue">
            <app-translate key="CLICK_READ_TERMS"></app-translate>
          </a>
        </div>
        <div class="sub-title">
          <div class="checkbox-span">
            <p-checkbox inputId="ambAccepted" formControlName="ambAccepted" [binary]="true"
              (onChange)="onAgreementChecked('ambAccepted', $event)" />
            <label for="ambAccepted" class="ml-2 sub-title agreement-term" [innerHTML]="ambAgreementTermHtml"></label>
          </div>
          <sp-control-error [control]="pageForm.controls['ambAccepted']"
            [messagesParameters]="[{ key: 'required', message: languageService.getTranslation('FIELD_MUST_BE_CONFIRMED') }]">
          </sp-control-error>
        </div>
      </div>
      <p-divider></p-divider>
    </div>
    <div>
      <div>
        <div class="title text-base">
          <app-translate key="ELECTRONIC_SIGNATURE"></app-translate>
        </div>
        <div class="sub-title mb-3">
          <app-translate key="ESIGN_DISCLOSURE"></app-translate>
        </div>
        <div class="col-12">
          <div class="flex flex-column">
            <label htmlFor="signature" class="form-label required">
              <app-translate key="ENTER_FIRST_LAST_NAME"></app-translate>:
            </label>
            <div>
              <input type="text" placeholder="" pInputText formControlName="signature" class="w-full input-margin"
                (focus)="sendCustomerInputMessage('signature name')" />
            </div>
            <sp-control-error [control]="pageForm.controls['signature']"
            [messagesParameters]="[{key : 'required', message : languageService.getTranslation('FIELD_MUST_BE_CONFIRMED')}]"></sp-control-error>
          </div>
        </div>
        <div class="sub-title mb-3 mt-3">
          <app-translate key="DIGITAL_SIGNATURE_ACKNOWLEDGEMENT"></app-translate>
        </div>
      </div>
      <div>
        <div class="mb-3">
          <p-button [label]="languageService.getTranslation('SUBMIT')" (onClick)="onFormSubmit()"
            styleClass="p-button-lg w-full p-button-primary" />
        </div>
        <div class="mb-3">
          <p-button [label]="languageService.getTranslation('CANCEL')" [link]="true" styleClass="w-full"
            (onClick)="onFormCancel()" />
        </div>
      </div>
      <div>
        <app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
      </div>
    </div>
  </div>
}

<app-confirm-popup [title]="languageService.getTranslation('MBA_CANCEL_CONFIRMATION_TEXT')"
  [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="showCancelDialog"
(Result)="onCancelConfirmation($event)"></app-confirm-popup>
